// Modules
import * as Yup from 'yup'

// Application
import { isValidMobilePhone } from '@brazilian-utils/brazilian-utils'

export const PhoneSchema = Yup.object().shape({
    cellphone: Yup.string()
        .required('Campo obrigatório')
        .test('cellphone', 'Insira um celular válido', (value: string): boolean => isValidMobilePhone(value)),
})
